export default "__VITE_ASSET__CQ0Yj$M7__"